/**
 * Utility function to get the full image URL from a relative path
 * Uses the API base URL from environment variables
 * Handles emulator URLs by converting production URLs to emulator URLs when needed
 */
export const getImageUrl = (imagePath: string | null | undefined): string => {
  if (!imagePath) {
    return '';
  }

  // If already a full URL, check if we need to convert to emulator URL
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    // Check if we're using emulators and the URL is a production storage URL
    const useEmulators = process.env.REACT_APP_USE_EMULATORS === 'true' || process.env.NODE_ENV === 'development';
    
    if (useEmulators && imagePath.includes('storage.googleapis.com')) {
      // Convert production storage URL to emulator URL
      // Format: https://storage.googleapis.com/bucket/path
      // To: http://localhost:9199/v0/b/bucket/o/path?alt=media
      const match = imagePath.match(/storage\.googleapis\.com\/([^/]+)\/(.+)/);
      if (match) {
        const bucket = match[1];
        const filePath = match[2];
        const encodedPath = encodeURIComponent(filePath);
        return `http://localhost:9199/v0/b/${bucket}/o/${encodedPath}?alt=media`;
      }
    }
    
    // Return as-is for other URLs
    return imagePath;
  }

  // Get base URL from environment or default to localhost:8080
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';
  
  // Extract base URL (remove /api suffix if present)
  const baseUrl = apiUrl.replace(/\/api$/, '');
  
  // Ensure imagePath starts with /
  const path = imagePath.startsWith('/') ? imagePath : `/${imagePath}`;
  
  return `${baseUrl}${path}`;
};

